import { render, staticRenderFns } from "./Traffic.vue?vue&type=template&id=96e58802&"
import script from "./Traffic.vue?vue&type=script&lang=js&"
export * from "./Traffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports